// Screenshots of the real product on the landing page (founder, 2026-11-02:
// "make the landing page so proper and irresistible", after Perplexity's hub:
// the product as the hero, real screens instead of drawings).
//
// Every picture is a real screen of ours: the component rendered with
// fictional data (Alex Morgan, Example Co, Sample Labs…), with the app's own
// stylesheets, in light and in dark (body.dark-theme), at 2x, as WebP. Never a
// real person, never a real account. Files: public/landing/*.webp. The sizes
// below are the files' own (in CSS pixels), so the page never jumps as they
// load; a shot of a screen with no dark mode (the extension's panel, which
// sits on the employer's page) has one file for both themes.
import React from 'react';

export const SHOTS = {
  find: {
    w: 1000, h: 530, dark: true,
    alt: 'The Jobs page searching for senior backend engineer near Austin, TX, with its filters open: each level, job type and company shows how many jobs it leaves. Sample data.',
  },
  jobs: {
    w: 560, h: 282, dark: true,
    alt: 'Jobs ranked for you: a list of jobs with a match score on each, and the top one open, with why you are seeing it. Sample data.',
  },
  resume: {
    w: 460, h: 229, dark: true,
    alt: 'A suggested change to a resume line: "Responsible for backend APIs" becomes "Built and owned the backend APIs for checkout, in Python and PostgreSQL", with Apply and Discard. Sample data.',
  },
  apply: {
    w: 1000, h: 620, dark: false,
    alt: 'An employer\'s application form filled in with Alex Morgan\'s details, and the AssistAlien panel beside it saying "All filled in. Press Submit." Sample data.',
  },
  autoapply: {
    w: 560, h: 280, dark: false,
    alt: 'The AssistAlien panel on an application: "All filled in. Press Submit. Look it over first." with 8 fields filled. Sample data.',
  },
  track: {
    w: 684, h: 652, dark: true,
    alt: 'The Applications page: 12 sent this week, a card asking whether one application was sent, and a Needs you list. Sample data.',
  },
  interview: {
    w: 760, h: 602, dark: true,
    alt: 'The interview coach on one story: what was going on, what you did and how it turned out, with a readiness score of 88 and one thing to add. Sample data.',
  },
  coach: {
    w: 560, h: 144, dark: true,
    alt: 'The interview coach\'s notes on a story: a readiness score of 88, and one thing to add. Sample data.',
  },
};

const src = (name, theme) => `${process.env.PUBLIC_URL || ''}/landing/${name}${SHOTS[name].dark ? `-${theme}` : ''}.webp`;

/**
 * One screenshot in its calm frame, with the small grey "Example" marker
 * (left off in the cards, whose previews fade into the card; the tab panels
 * say "Example · sample data" beside their numbers).
 * Both themes' files carry the alt text; the one for the other theme is
 * display: none (LandingPage.css), which also keeps a lazy one from loading.
 */
export default function LandingShot({ name, eager = false, className = '', mark = true }) {
  const s = SHOTS[name];
  const img = (theme) => (
    <img
      className={`lp-shot-img${s.dark ? ` is-${theme}` : ''}`}
      src={src(name, theme)}
      width={s.w}
      height={s.h}
      alt={s.alt}
      loading={eager ? 'eager' : 'lazy'}
      decoding="async"
    />
  );
  return (
    <figure className={`lp-shot ${className}`.trim()} style={{ maxWidth: s.w }}>
      <div className="lp-shot-frame">
        {img('light')}
        {s.dark && img('dark')}
      </div>
      {mark && <figcaption className="lp-shot-mark">Example</figcaption>}
    </figure>
  );
}
